import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import defaultuniversity from "assets/images/university/defaultuniversity.png";
import SoftTypography from "components/SoftTypography";
import LanguageIcon from "@mui/icons-material/Language";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import usersIcon from "assets/images/university/usersicon.png";
import statusIcon from "assets/images/university/statusicon.png";
import statusActive from "assets/images/city/statusActive.svg";
import statusInactive from "assets/images/city/statusInactive.svg";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useGetuniversitydetailsQuery } from "store/api/universities.api";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import UsersTable from "./components/usersTable";
import ChangeStatus from "./components/changeStatus";
import useStore from "store/hook";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import DeleteUniversity from "./components/deleteUniversity";
import ActivateDeactivateUser from "layouts/users/components/ActivateDeactivateuser";
import DeletedLabel from "components/DeletedLabel";
import ChangeSubscriptionRequired from "./components/changeSubscriptionRequired";

function UniversityDetails() {
  const [universityDetails, setUniversityDetails] = useState({
    university_name: "",
    university_domain: "",
    university_image: "",
    university_users: "",
    university_status: "",
    is_universitydeleted: false,
    subscription_required: false,
  });

  const { id } = useParams();
  const location = useLocation();
  const returnPath = location.state?.from || "/schools";
  const { store, setDialogue } = useStore();
  const logout = useLogout();

  const { data, isLoading, isFetching, error, refetch } = useGetuniversitydetailsQuery({
    school_id: id,
  });

  useEffect(() => {
    if (data?.status === 1) {
      const { school_name, school_image, school_domain, is_deleted, is_active, users, _id, subscription_required } =
        data?.data;
      setUniversityDetails({
        university_name: school_name || "",
        university_domain: school_domain || "",
        university_image: school_image || "",
        university_users: users || 0,
        university_status: is_active ? "active" : "inactive",
        status: is_active,
        is_universitydeleted: is_deleted,
        university_id: _id,
        subscription_required: subscription_required || false,
      });
    } else if (data?.status == 0) {
      toast?.error(Formatmessage(data?.message));
    } else if (data?.status == 10) {
      logout();
    }
  }, [data, id]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox
        sx={{ pr: { xs: 1, sm: 2, md: 4 }, pl: { xs: 1, sm: 2, md: 2 } }}
        position="absolute"
        mt={-22}
        width="100%"
      >
        <SoftBox width="100%" display="flex" sx={{ pb: 4 }}>
          {isLoading || isFetching ? (
            <SoftBox
              sx={{
                height: "calc(70vh)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FadeLoader color="#3DC2EB" />
            </SoftBox>
          ) : (
            <SoftBox
              sx={{ py: 2, gap: 2.5, flexDirection: { xs: "column", md: "column" } }}
              borderRadius="md"
              display="flex"
              alignItems="start"
              justifyContent="center"
              width="100%"
            >
              <SoftBox
                sx={{ py: 2, gap: 2.5, flexDirection: { xs: "column", md: "row" } }}
                borderRadius="md"
                display="flex"
                alignItems="start"
                justifyContent="center"
                width="100%"
              >

                <SoftBox
                  borderRadius="md"
                  border="1px solid #D8E0E8"
                  sx={{ backgroundColor: "white.main", width: { xs: "100%", md: "70%" }, p: 1.5 }}
                >
                  <SoftBox
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                    p={1}
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                      alignItems: { xs: "center", sm: "start" },
                    }}
                  >
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      flex={1}
                      gap={1}
                      sx={{
                        ml: { xs: 0, sm: 20 },
                      }}
                    >
                      {/* University Image */}
                      <SoftBox
                        height="140px"
                        width="140px"
                        borderRadius="lg"
                        border="1px solid #D8E0E8"
                        sx={{
                          backgroundImage: `url(${
                            universityDetails?.university_image || defaultuniversity
                          })`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                        }}
                      />

                      {/* University Name + Domain */}
                      <SoftTypography
                        align="center"
                        sx={{ fontSize: 32 }}
                        color="black"
                        fontWeight="normal"
                      >
                        {universityDetails?.university_name}
                      </SoftTypography>

                      <SoftBox align="center" display="flex" alignItems="center" gap={1}>
                        <LanguageIcon sx={{ color: "primary.main" }} />
                        <SoftTypography sx={{ fontSize: 15 }} color="black" fontWeight="normal">
                          {universityDetails?.university_domain}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    {universityDetails?.is_universitydeleted ? (
                      <SoftBox display="flex" gap={1}>
                        {" "}
                        <DeletedLabel />
                      </SoftBox>
                    ) : (
                      <SoftBox display="flex" gap={1} alignItems="center">
                        <SoftBox
                          display="flex"
                          sx={{
                            py: 0.8,
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setDialogue({
                              type: "changeStatus",
                              isOpen: true,
                              action: "",
                              schoolID: universityDetails?.university_id,
                            })
                          }
                        >
                          <SoftBox
                            component="img"
                            src={universityDetails?.status ? statusActive : statusInactive}
                            alt={universityDetails?.status ? "Active" : "Inactive"}
                            sx={{
                              width: universityDetails?.status ? 30 : 31,
                              height: 20,
                              display: "block",
                            }}
                          />
                        </SoftBox>

                        <SoftBox
                          display="flex"
                          sx={{
                            py: 0.8,
                            px: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            borderRadius: "xxl",
                            backgroundColor: "purple.light",
                            gap: 0.5,
                          }}
                          onClick={() =>
                            setDialogue({
                              type: "changeSubscriptionRequired",
                              isOpen: true,
                              action: "",
                              schoolID: universityDetails?.university_id,
                              name: universityDetails?.university_name,
                              subscription_required: universityDetails?.subscription_required,
                            })
                          }
                        >
                          <CreditCardIcon sx={{ height: 18, width: 18, color: "purple.main" }} />
                          <SoftTypography
                            fontWeight="normal"
                            sx={{ color: "purple.main", fontSize: 12 }}
                          >
                            {universityDetails?.subscription_required ? "Required" : "Not Required"}
                          </SoftTypography>
                        </SoftBox>

                        {/* Edit */}
                        <SoftBox
                          component={Link}
                          to={`/edit-school/${id}`}
                          state={{ from: returnPath }}
                          borderRadius="xxl"
                          display="flex"
                          sx={{
                            backgroundColor: "light.main",
                            width: "80px",
                            py: 0.8,
                            gap: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <NoteAltOutlinedIcon
                            sx={{ height: 20, width: 20, color: "yellow.main" }}
                          />
                          <SoftTypography
                            fontWeight="normal"
                            sx={{ color: "yellow.main", fontSize: 13 }}
                          >
                            Edit
                          </SoftTypography>
                        </SoftBox>

                        {/* Delete */}
                        <SoftBox
                          onClick={() =>
                            setDialogue({
                              type: "deleteUniversity",
                              isOpen: true,
                              action: "",
                              schoolID: id,
                            })
                          }
                          borderRadius="xxl"
                          display="flex"
                          sx={{
                            backgroundColor: "red.light",
                            width: "80px",
                            py: 0.8,
                            gap: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <DeleteIcon sx={{ height: 20, width: 20, color: "red.main" }} />
                          <SoftTypography
                            fontWeight="normal"
                            sx={{ color: "red.main", fontSize: 13 }}
                          >
                            Delete
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    )}
                  </SoftBox>
                </SoftBox>

                <SoftBox
                  display="flex"
                  sx={{
                    width: { xs: "100%", md: "30%" },
                    height: "100%",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <SoftBox
                    borderRadius="md"
                    border="1px solid #D8E0E8"
                    py={1}
                    px={2}
                    sx={{ backgroundColor: "white.main", width: "100%", height: "100%" }}
                  >
                    <SoftBox
                      width="100%"
                      display="flex"
                      height="100%"
                      sx={{ alignItems: "center", justifyContent: "space-between" }}
                    >
                      <SoftBox
                        display="flex"
                        height="100%"
                        sx={{
                          alignItems: "center",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <SoftTypography sx={{ fontSize: 16 }} color="black" fontWeight="medium">
                          Users
                        </SoftTypography>

                        <SoftBox
                          display="flex"
                          alignItems="end"
                          justifyContent="end"
                          sx={{ fontSize: 40 }}
                          color="primary"
                          fontWeight="bold"
                        >
                          {universityDetails?.university_users}
                        </SoftBox>
                      </SoftBox>

                      <SoftBox>
                        <SoftBox
                          height="60px"
                          width="60px"
                          sx={{
                            backgroundImage: `url(${usersIcon})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                          }}
                        />
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>

                  <SoftBox
                    borderRadius="md"
                    border="1px solid #D8E0E8"
                    py={1}
                    px={2}
                    sx={{ backgroundColor: "white.main", width: "100%", height: "100%" }}
                  >
                    <SoftBox
                      width="100%"
                      display="flex"
                      height="100%"
                      sx={{ alignItems: "center", justifyContent: "space-between" }}
                    >
                      <SoftBox
                        display="flex"
                        height="100%"
                        pb={2}
                        sx={{
                          alignItems: "start",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <SoftTypography sx={{ fontSize: 16 }} color="black" fontWeight="medium">
                          Status
                        </SoftTypography>

                        {universityDetails?.is_universitydeleted ? (
                          <SoftBox display="flex" gap={1}>
                            {" "}
                            <DeletedLabel />
                          </SoftBox>
                        ) : (
                          <SoftBox
                            borderRadius="xxl"
                            width="120px"
                            display="flex"
                            sx={{
                              backgroundColor:
                                universityDetails?.university_status == "active"
                                  ? "green.main"
                                   : "error.main",
                              color: "white.main",
                              px: 1,
                              py: 0.5,
                              alignItems: "center",
                              justifyContent: "center",
                              textTransform: "capitalize",
                            }}
                          >
                            {universityDetails?.university_status}
                          </SoftBox>
                        )}
                      </SoftBox>

                      <SoftBox>
                        <SoftBox
                          height="60px"
                          width="60px"
                          sx={{
                            backgroundImage: `url(${statusIcon})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                          }}
                        />
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </SoftBox>

              <UsersTable users={universityDetails?.university_users} />
            </SoftBox>
          )}
        </SoftBox>

        <ChangeStatus />
        <DeleteUniversity />
        <ActivateDeactivateUser />
        <ChangeSubscriptionRequired />
      </SoftBox>
    </DashboardLayout>
  );
}

export default UniversityDetails;
